import { render, staticRenderFns } from "./ThirdPartyLoginV3.vue?vue&type=template&id=4b547813&scoped=true&"
import script from "./ThirdPartyLoginV3.vue?vue&type=script&lang=js&"
export * from "./ThirdPartyLoginV3.vue?vue&type=script&lang=js&"
import style0 from "./ThirdPartyLoginV3.vue?vue&type=style&index=0&id=4b547813&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b547813",
  null
  
)

export default component.exports